
import { useState, useEffect } from 'react';

interface HeaderProps {
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
}

export default function Header({ menuOpen, setMenuOpen }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white/95'}`}>
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="flex items-center justify-between h-20 max-w-[1000px] mx-auto">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <i className="ri-restaurant-2-fill text-3xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
            <span className="ml-3 text-2xl font-bold bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent" style={{ fontFamily: '"Pacifico", serif' }}>Cooking Studio</span>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-pink-400 transition-colors whitespace-nowrap cursor-pointer">ホーム</button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-pink-400 transition-colors whitespace-nowrap cursor-pointer">教室について</button>
            <button onClick={() => scrollToSection('business')} className="text-gray-700 hover:text-pink-400 transition-colors whitespace-nowrap cursor-pointer">受講コース紹介</button>
            <button onClick={() => scrollToSection('blog')} className="text-gray-700 hover:text-pink-400 transition-colors whitespace-nowrap cursor-pointer">ブログ</button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-pink-400 transition-colors whitespace-nowrap cursor-pointer">お客様の声</button>
            <button onClick={() => scrollToSection('recruit')} className="text-gray-700 hover:text-pink-400 transition-colors whitespace-nowrap cursor-pointer">求人情報</button>
            <button onClick={() => scrollToSection('contact')} className="bg-gradient-to-r from-pink-400 to-orange-400 text-white px-6 py-2 rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">お問い合わせ</button>
          </nav>

          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-800`}></i>
          </button>
        </div>

        {menuOpen && (
          <nav className="md:hidden pb-6 space-y-4 max-w-[1000px] mx-auto">
            <button onClick={() => scrollToSection('hero')} className="block w-full text-left text-gray-700 hover:text-pink-400 transition-colors py-2 cursor-pointer">ホーム</button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-gray-700 hover:text-pink-400 transition-colors py-2 cursor-pointer">教室について</button>
            <button onClick={() => scrollToSection('business')} className="block w-full text-left text-gray-700 hover:text-pink-400 transition-colors py-2 cursor-pointer">受講コース紹介</button>
            <button onClick={() => scrollToSection('blog')} className="block w-full text-left text-gray-700 hover:text-pink-400 transition-colors py-2 cursor-pointer">ブログ</button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-gray-700 hover:text-pink-400 transition-colors py-2 cursor-pointer">お客様の声</button>
            <button onClick={() => scrollToSection('recruit')} className="block w-full text-left text-gray-700 hover:text-pink-400 transition-colors py-2 cursor-pointer">求人情報</button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left bg-gradient-to-r from-pink-400 to-orange-400 text-white px-6 py-3 rounded-full hover:shadow-lg transition-all text-center cursor-pointer">お問い合わせ</button>
          </nav>
        )}
      </div>
    </header>
  );
}
